import { makeChartComp } from '../../util/makeChartComp';
var BidirectionalBarChart = makeChartComp('BidirectionalBar');
export default BidirectionalBarChart;
